// eslint-disable-next-line import/no-cycle
import {
  ComponentNameEnum, ConfigurationPanelStructureItemEnum, FieldsGroup,
  TemplateStructureEnum, ElementPartTypeEnum, TabItem,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import getBorderRadiusFieldConfig from '@/components/template-builder/config/fields/border-radius-config';
// eslint-disable-next-line import/no-cycle
import {
  refreshButtonVml,
  setAttribute,
  setClass,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
  setMenuItems,
  setMenuOrientation,
  setMenuResponsive,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName,
  getClassByName,
  getCssPropertyByName,
  getMenuItems,
  getMenuResponsive,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import menuLayoutFieldConfig from '@/components/template-builder/config/fields/menu-layout-config';
// eslint-disable-next-line import/no-cycle
import menuInputGroupConfig from '@/components/template-builder/config/fields/menu-input-group-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';
import getTextAlignNoJustifyFieldConfig from "@/components/template-builder/config/fields/text-align-no-justify-config";

const widgetMenuFieldsConfig: Array<FieldsGroup | TabItem> = [
  {
    type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
    label: 'templateBuilder.configs.widgetConfiguration',
    selector: 'body #spm_body #{ID}',
    items: [
      {
        label: 'templateBuilder.fields.menuLayout',
        selector: '{SELECTOR} > tbody > tr > th > table',
        properties: [{
          name: 'spm_menu_', getter: getClassByName, setters: [setClass, setMenuOrientation],
        }],
        ...menuLayoutFieldConfig,
      },
      {
        label: 'templateBuilder.fields.menuConfiguration',
        selector: '{SELECTOR} > tbody > tr > th > table',
        properties: [
          {
            name: 'menuItems',
            getter: getMenuItems,
            setters: [setMenuItems],
            refreshWidgetFields: true,
          },
        ],
        ...menuInputGroupConfig,
      },
    ],
  },
  {
    type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
    tabItemType: TemplateStructureEnum.GROUP,
    label: 'templateBuilder.configs.widgetStyles',
    canSave: true,
    elementPartType: ElementPartTypeEnum.STYLES,
    tabPanel: {
      items: [
        {
          type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
          label: 'templateBuilder.configs.widgetBlockStyles',
          selector: 'body #spm_body #{ID}',
          items: [
            {
              label: 'templateBuilder.fields.menuAlignment',
              selector: '{SELECTOR} > tbody > tr > th > table',
              properties: [{ name: 'align', getter: getAttributeByName, setters: [setAttribute] }],
              ...getElementAlignFieldConfig(),
            },
            {
              label: 'templateBuilder.fields.font',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item a',
              properties: [
                { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
              ],
              ...fontFieldConfig,
            },
            {
              label: 'templateBuilder.fields.textAlign',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item, {SELECTOR} > tbody > tr > th > table .spm_menu_item a',
              properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty] }],
              ...getTextAlignNoJustifyFieldConfig(),
            },
            {
              label: 'templateBuilder.fields.menuItemBackgroundColor',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item > table > tbody > tr > th',
              properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
              ...getColorFieldConfig(),
            },
            {
              label: 'templateBuilder.fields.menuItemBorderRadius',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item > table > tbody > tr > th',
              properties: [{
                name: 'border-radius',
                getter: getCssPropertyByName,
                setters: [setCssProperty],
              }],
              ...getBorderRadiusFieldConfig('0px'),
            },
            {
              label: 'templateBuilder.fields.menuItemBorders',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item > table > tbody > tr > th',
              properties: [
                { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
              ],
              ...bordersFieldConfig,
            },
            {
              label: 'templateBuilder.fields.menuItemInnerPadding',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item > table > tbody > tr > th',
              properties: [
                { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
              ],
              componentName: ComponentNameEnum.SPACES,
              options: {
                ...getVerticalSpacesFieldConfig('padding').options,
                ...getHorizontalSpacesFieldConfig('padding').options,
              },
            },
            {
              label: 'templateBuilder.fields.menuItemSpacing',
              selector: '{SELECTOR} > tbody > tr > th > table .spm_menu_item',
              properties: [
                { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
              ],
              componentName: ComponentNameEnum.SPACES,
              options: {
                ...getVerticalSpacesFieldConfig('padding').options,
                ...getHorizontalSpacesFieldConfig('padding').options,
              },
            },
            {
              label: 'templateBuilder.fields.borders',
              selector: '{SELECTOR}',
              properties: [
                { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
              ],
              ...bordersFieldConfig,
            },
            {
              label: 'templateBuilder.fields.menuResponsiveDisplay',
              selector: '{SELECTOR} > tbody > tr > th > table',
              properties: [{
                name: 'spm_responsive_menu', getter: getMenuResponsive, setters: [setMenuResponsive],
              }],
              disableHandler: () => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true',
              disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
              componentName: ComponentNameEnum.BUTTON_GROUP,
              options: {
                yes: {
                  title: 'templateBuilder.fields.menuResponsiveYes',
                  label: 'templateBuilder.fields.menuResponsiveYes',
                  property: 'spm_responsive_menu',
                  defaultValue: 'yes',
                },
                no: {
                  title: 'templateBuilder.fields.menuResponsiveNo',
                  label: 'templateBuilder.fields.menuResponsiveNo',
                  property: 'spm_responsive_menu',
                  defaultValue: 'yes',
                },
              },
            },
          ],
        },
        getWidgetCommonStylesGroup('{SELECTOR} > tbody > tr > th'),
      ],
    },
  },
  getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
];

export default widgetMenuFieldsConfig;
